import { DateTime } from 'luxon';
import { call } from 'redux-saga/effects';
import { v4 as uuid } from 'uuid';
import { getLogger } from '../../utils/core';
import { resourceSagaUtils, resourceStoreTypes } from '../core';
// import { getLastSyncDate } from './achievementsSelectors';
import * as actions from './achievementsActions';
const log = getLogger('data/freeToSpend/freeToSpendSagas.js');

const mkResourceConfigAchievements = (props) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'achievements',
    resourceBaseUrl: '/gamification/achievements',
    // getLastSyncDate,
    ...props,
  });

export function* getAchievementsActionWatcher() {
  const config = mkResourceConfigAchievements({
    successAction: actions.getAchievementsSuccess,
    failureAction: actions.getAchievementsFailure,
  });
  yield resourceSagaUtils.takeAndDebounce(actions.getAchievements, resourceSagaUtils.qcsSyncGetResources, config);
}

export function* getEventsActionWatcher() {
  yield resourceSagaUtils.takeAndDebounce(actions.sendAchievementsEvent, callAchievementsEvent);
}

function* callAchievementsEvent(action) {
  const date = DateTime.local().toISODate();
  const config = resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'achievements',
    resourceBaseUrl: '/gamification/event',
    transformResourceToRequestData: (resource) => ({
      ...resource,
      eventId: uuid(),
      eventOn: date,
    }),
    successAction: actions.sendAchievementsEventSuccess,
    failureAction: actions.sendAchievementsEventFailure,
    transformResourceWithResponse: () => null,
  });
  try {
    yield call(resourceSagaUtils.qcsSyncCreateResource, config, action);
  } catch (error) {
    log.error('gamification event error ', error);
  }
}

export default [getAchievementsActionWatcher, getEventsActionWatcher];
